import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Satoshi';
    src: url('/fonts/Satoshi-Light.woff2') format('woff2'),
         url('/fonts/Satoshi-Light.woff') format('woff');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }
  
  @font-face {
    font-family: 'Satoshi';
    src: url('/fonts/Satoshi-Regular.woff2') format('woff2'),
         url('/fonts/Satoshi-Regular.woff') format('woff');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
  
  @font-face {
    font-family: 'Satoshi';
    src: url('/fonts/Satoshi-Medium.woff2') format('woff2'),
         url('/fonts/Satoshi-Medium.woff') format('woff');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  :root {
    /* Base Colors */
    --color-background: #FBFBFB;
    --color-text: #1D1D1F;
    
    /* Accent Colors */
    --color-primary: #BA865E;
    --color-secondary: #C4845F;
    --color-dark-gray: #424245;
    --color-medium-gray: #86868b;
    --color-light-gray: #F5F5F7;
    
    /* Spacing */
    --spacing-paragraph: 1.5rem;
    --spacing-section-small: 2rem;
    --spacing-section-large: 4rem;
  }

  html {
    font-size: 16px;
  }

  body {
    font-family: 'SF Pro Text', 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: var(--color-text);
    background-color: var(--color-background);
    overflow-x: hidden;
    line-height: 1.5;
    letter-spacing: -0.01em;
  }

  button {
    font-family: 'SF Pro Text', 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    cursor: pointer;
    font-weight: 500;
    outline: none;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'SF Pro Display', 'Satoshi', sans-serif;
    letter-spacing: -0.025em;
  }
  
  h1 {
    font-weight: 300;
    font-size: 60px;
  }
  
  h2 {
    font-weight: 400;
    font-size: 34px;
  }
  
  h3 {
    font-weight: 500;
    font-size: 22px;
  }
  
  p {
    margin-bottom: var(--spacing-paragraph);
    color: var(--color-medium-gray);
  }
  
  ::selection {
    background-color: rgba(186, 134, 94, 0.2);
  }
`;

export default GlobalStyle; 